import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ToggleSidebarService {

  private toggleState = new BehaviorSubject<[string,boolean]>(['', true]);
  public toggleState$ = this.toggleState.asObservable();
  private toggleVal = false;
  
  emitData(val:any){
     this.toggleVal = !this.toggleVal;
     this.toggleState.next([val, this.toggleVal]);
  }

  private toggle = new BehaviorSubject('');
  
  public setToggleButtonClick(title:string) {
    this.toggle.next(title);
  }

  public getToggleButtonClick(): Observable<string> {
    return this.toggle.asObservable();
  }

}
